const initialState = {
    list: []
}

export default function group(state = initialState, action) {
    switch (action.type) {
        case 'GET_DATA_GROUP': {
            return {
                ...state,
                list: action.data
            }
        }
        default: return state
    }
}